<template>
  <div class="progress">
    <div class="progress-item"
      v-for="(item, index) in arr"
      :key="item"
      :class="{
        'progress-item--first' : index === 0,
        'progress-item--end' : index === arr.length - 1,
        'progress-item--select' : index === activeIndex
      }">
      <div class="progress-item-top">
        <div class="progress-item-top__left"></div>
        <div class="progress-item-top__right"></div>
      </div>
      <div class="progress-item-bottom">
        <div class="progress-item-bottom__left"></div>
        <div class="progress-item-bottom__right"></div>
      </div>
      <div class="progress-item__text">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progressBar',
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    arr: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.progress{
  display: flex;
  // transform: translateY(10px);
  &-item{
    position: relative;
    flex: 1;
    margin: 0 2px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    &-top{
      position: absolute;
      bottom: 49.5%;
      height: 14px;
      width: 100%;
      &__left{
        position: absolute;
        transform: skew(45deg);
        background: #99dcf3;
        height: 100%;
        width: 60%;
      }
      &__right{
        position: absolute;
        left: 40%;
        transform: skew(45deg);
        background: #99dcf3;
        height: 100%;
        width: 60%;
      }
    }
    &__text{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: white;
      width: 100%;
      font-size: 12px;
    }
    &-bottom{
      position: absolute;
      top: 49.5%;
      height: 14px;
      width: 100%;
      &__left{
        position: absolute;
        transform: skew(-45deg);
        background: #99dcf3;
        height: 100%;
        width: 60%;
      }
      &__right{
        position: absolute;
        left: 40%;
        transform: skew(-45deg);
        background: #99dcf3;
        height: 100%;
        width: 60%;
      }
    }
    &--first{
      .progress-item-top__left, .progress-item-bottom__left{
        transform: skew(0);
      }
    }
    &--end{
      .progress-item-top__right, .progress-item-bottom__right{
        transform: skew(0);
      }
    }
    &--select{
      .progress-item-top__left, .progress-item-top__right, .progress-item-bottom__left, .progress-item-bottom__right{
        background: #00a0c7;
      }
    }
  }
}
</style>
